import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import logo from '../assets/logo.png'

const Footer = () => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  const footerLinks = {
    [t('footer.headers.services')]: [
      { label: t('footer.links.bioinformatics'), path: '/service/bioinformatics' },
      { label: t('footer.links.aiMl'), path: '/service/ai-ml' },
      { label: t('footer.links.consultancy'), path: '/service/consultancy' },
      { label: t('footer.links.scientificWriting'), path: '/service/scientific-writing' },
      { label: t('footer.links.allServices'), path: '/service' },
    ],
    [t('footer.headers.company')]: [
      { label: t('footer.links.about'), path: '/about' },
      { label: t('footer.links.whyUs'), path: '/why-us' },
      { label: t('footer.links.contact'), path: '/contact' },
    ],
    [t('footer.headers.resources')]: [
      { label: t('footer.links.dataSecurity'), path: '/service/data-security' },
      { label: t('footer.links.serviceProcess'), path: '/service-process' },
      { label: t('footer.links.technicalResources'), path: '/technical-resources' },
    ],
  }

  return (
    <footer className="bg-text-main text-white/80">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-10">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">
          {/* Brand */}
          <div className="lg:w-1/4">
            <div className="flex flex-col items-start">
              <a href="/" className="block mb-4 flex-shrink-0" data-discover="true">
                <img src={logo} alt="AlgoMori" className="w-[110px] h-auto object-contain brightness-0 invert opacity-80" />
              </a>
              <div className="space-y-2 text-sm text-white/60 leading-relaxed">
                <p className="font-semibold text-white/80">{t('footer.companyInfo.name')}</p>
                <p className="text-white/50">{t('footer.companyInfo.address1')}</p>
                <p className="text-white/50">{t('footer.companyInfo.address2')}</p>
                <a href="mailto:info@algomori.co.jp" className="text-primary-light hover:text-primary-200 transition-colors block mt-3">info@algomori.co.jp</a>
              </div>
            </div>
          </div>

          {/* Link columns */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-8 lg:gap-10">
            {Object.entries(footerLinks).map(([category, links], i) => (
              <div key={category} className={i === 1 ? 'pl-[50px]' : ''}>
              <h4 className="text-xs font-bold text-white/50 uppercase tracking-widest mb-4">{category}</h4>
              <ul className="space-y-2.5">
                {links.map((link, i) => (
                  <li key={i}>
                    <Link to={link.path} className="text-sm text-white/40 hover:text-primary-light transition-colors">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/30">{t('footer.copyright', { year: currentYear })}</p>
          <p className="text-xs text-white/20">{t('footer.location')}</p>
        </div>
      </div>
    </footer>
  )
}


export default Footer